const CONFIG = {
  API_BASE_URL: "https://tts.787888j.com"
 //API_BASE_URL: "http://localhost:5000"
};
export default CONFIG;